// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import AngleDown from "@flip/XDL/Icons/AngleDown";
import { xBaseTheme } from "@flip/XDL/types";
import { IconWrapper } from "@insite/mobius/Icon";
import SelectPresentationPropsDefault from "@insite/mobius/Select/presentationProps";
import { css } from "styled-components";

export default {
    defaultProps: {
        ...SelectPresentationPropsDefault,
        iconProps: {
            src: AngleDown,
            size: 10,
            color: "common.ui5",
            css: css`
                &&& {
                    display: flex;
                    justify-content: flex-end;
                    padding-right: 10px;
                    width: auto;
                }
                svg {
                    width: 9px;
                    height: 12px;
                }
            `,
        },
        mergeCss: true,
    },
} as xBaseTheme["select"];
